import HTTP from "@/service/http";
const state = {
    loginStatus:false,//用户登录状态
    username:sessionStorage.getItem('username')||null,
    user_id:sessionStorage.getItem('user_id')||null,
    type:sessionStorage.getItem('type')||null,
    access_token:sessionStorage.getItem('access_token')||null,
    customer_flag:sessionStorage.getItem('customer_flag')||null,
};

const mutations={
    //state为局部state
    initUserInfo(state,data){
        sessionStorage.setItem('username',data.username);
        sessionStorage.setItem('user_id',data.user_id);
        sessionStorage.setItem('type',data.type);
        sessionStorage.setItem('access_token',data.access_token);
        sessionStorage.setItem('customer_flag',data.customer_flag);
        state.access_token = data.access_token;
        state.username = data.username;
        state.user_id = data.user_id;
        state.type = data.type;
        state.customer_flag = data.customer_flag;
    },
    setLoginStatus(state,status){
        state.loginStatus = status;
    },
    clearUserInfo(state){//清除用户数据
        state.loginStatus = false,//用户登录状态
        state.user_id = null;
        state.type =null,
        state.username = null;
        state.access_token = null;
        state.customer_flag = null;

    }
};

const actions={
    doUserLogin ({commit }, data) {//处理用户登录
        return new Promise((resolve,reject)=>{
            const para = data.para;
            const head = data.head;
            HTTP.doLogin(para,head).then(resp=>{
                let data = resp;
                if(data.user_id !== undefined){
                    commit('initUserInfo',{
                        username:data.username,
                        user_id:data.user_id,
                        type:data.type,
                        access_token:data.access_token,
                        customer_flag:data.customer_flag,
                    });
                    commit('setLoginStatus',true);
                    resolve(resp);

                }else{
                    commit('setLoginStatus',false);
                    reject('登录失败');
                }
            }).catch(()=>{
                commit('setLoginStatus',false);
                reject('登录失败');
            })
        })
    },
    async doLogout({commit}) {
        await HTTP.doLogout();
        commit('clearUserInfo');
        return true;
    }
};

export default {
    namespaced:true,//用于在全局引用此文件里的方法时标识这一个的文件名
    state,
    mutations,
    actions,
}
